import PropTypes from 'prop-types';

export const OEInfoMessageViewType = {
    none:                       'none',
    std:                        'std'
};

//
export const OEInfoMessageViewProps = {

    filterDecl: {
        includeTargets:         PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        excludeTargets:         PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    }
};

OEInfoMessageViewProps.filter = PropTypes.shape(OEInfoMessageViewProps.filterDecl);

OEInfoMessageViewProps.configDecl = {
    type:                       PropTypes.string,
    filter:                     OEInfoMessageViewProps.filter
};

OEInfoMessageViewProps.config = PropTypes.shape(OEInfoMessageViewProps.configDecl);

OEInfoMessageViewProps.propTypes = {
    moduleId:                   PropTypes.string,
    target:                     PropTypes.string,
    config:                     OEInfoMessageViewProps.config
};

//
export const OEInfoMessageViewConfigFactory = {

    buildStdConfig(type = OEInfoMessageViewType.none, includeTargets = undefined, excludeTargets = undefined)    {
        return {
            type:               type,
            filter: {
                includeTargets: includeTargets,
                excludeTargets: excludeTargets
            }
        };
    }
};

//
OEInfoMessageViewProps.defaultProps = {
    moduleId:                   '',
    config:                     OEInfoMessageViewConfigFactory.buildStdConfig(OEInfoMessageViewType.none)
};